/* eslint-disable import/prefer-default-export -- Reason: legacy suppression retained until the owning code is migrated or cleaned up. */
export const CAN_USE_DOM =
    typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined';
